import React from "react";

const MyRecordsGenotype = () => {
  return (
    <div className="patient-details_first-section">
      <h3>Genotype</h3>
      <span className="genotype_input"></span>
    </div>
  );
};

export default MyRecordsGenotype;
